import { gc } from "./declarations";

/**
 * The echo channel routes
 */
export const channelRoutes = {
    currentUser: () => `App.Models.User.${gc.user.id}`,
    company: (companyId) => `App.Models.Company.${companyId}`,
}